import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

/** Dto stockant les informations nécessaires au paramètrage coté client des sparkle d'une instance d'écran. */
export interface IIsiDtoCiaInstanceScreenForClient extends IIsiDataTransferObject  {
    /** Liste des sparkle définis sur l'écran. */
    sparkles?: IIsiDtoSparkleForClient[];
    /** Identifiant de l'instance de l'écran */
    id?: string;
}
/** Dto stockant les informations nécessaires au paramètrage d'un sparkle */
export interface IIsiDtoSparkleForClient extends IIsiDataTransferObject  {
    /** Nom du controle associé au sparkle */
    position?: string;
    /** Nom de la fonction appelé */
    fonction?: IIsiDtoCiaFunctionForClient[];
    /** Identifiant d'un sparkle */
    id?: string;
}
/** Dto stockant les informations  */
export interface IIsiDtoCiaFunctionForClient extends IIsiDataTransferObject  {
}
/** Dto stockant les informations  */
export interface IIsiDtoCiaFunction extends IIsiDataTransferObject  {
    /** Liste des sources de données permettant d'interroger l'I.A. */
    destinations?: IIsiDtoDestination[];
    /** Liste des sources de données permettant d'interroger l'I.A. */
    sources?: IIsiDtoSource[];
    /** Phrase formaulant lal demande au moter d'I.A. */
    promptPathPhrase?: string;
    /** Identifiant du connecteur à utiliser */
    applicationIsiId?: string;
    /** Identifiant de la fonction de l'IA a utiliser */
    id?: string;
}
/** Dto stockant les informations définissant la destination des données issue de l'I.A. */
export interface IIsiDtoDestination extends IIsiDataTransferObject  {
    /** identifiant du type destination */
    idType?: string;
    /** type de la destination */
    type?: string;
    /** Identifiant de la destination */
    id?: string;
}
/** Dto stockant les informations définissant la destination des données issue de l'I.A. */
export class IsiDtoDestination extends IsiDataTransferObject implements IIsiDtoDestination {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.Engine.IsiDtoDestination, Isilog.IsiFramework.IsiDataTransferObject";
    /** identifiant du type destination */
    idType?: string;
    /** type de la destination */
    type?: string;
    /** Identifiant de la destination */
    id?: string;

    constructor(data?: IIsiDtoDestination) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idType = _data["idType"] !== undefined ? _data["idType"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoDestination): IsiDtoDestination {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoDestination();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["idType"] = this.idType !== undefined ? this.idType : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
/** Dto stockant les informations nécessaires au paramètrage d'un sparkle */
export interface IIsiDtoSource extends IIsiDataTransferObject  {
    /** Nom du controle associé au sparkle */
    idType?: string;
    /** Nom de la fonction appelée */
    type?: string;
    /** Identifiant d'un sparkle */
    id?: string;
}
/** Dto stockant les informations nécessaires au paramètrage d'un sparkle */
export class IsiDtoSource extends IsiDataTransferObject implements IIsiDtoSource {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.Engine.IsiDtoSource, Isilog.IsiFramework.IsiDataTransferObject";
    /** Nom du controle associé au sparkle */
    idType?: string;
    /** Nom de la fonction appelée */
    type?: string;
    /** Identifiant d'un sparkle */
    id?: string;

    constructor(data?: IIsiDtoSource) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.idType = _data["idType"] !== undefined ? _data["idType"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoSource): IsiDtoSource {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["idType"] = this.idType !== undefined ? this.idType : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
/** Dto stockant les informations concernant les fonctions disponibles pour un connecteur d'IA */
export class IsiDtoCiaFunction extends IsiDataTransferObject implements IIsiDtoCiaFunction {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.Engine.IsiDtoCiaFunction, Isilog.IsiFramework.IsiDataTransferObject";
    /** Liste des sources de données permettant d'interroger l'I.A. */
    destinations?: IsiDtoDestination[];
    /** Liste des sources de données permettant d'interroger l'I.A. */
    sources?: IsiDtoSource[];
    /** Phrase formaulant lal demande au moter d'I.A. */
    promptPathPhrase?: string;
    /** Identifiant du connecteur à utiliser */
    applicationIsiId?: string;
    /** Identifiant de la fonction de l'IA a utiliser */
    id?: string;

    constructor(data?: IIsiDtoCiaFunction) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.destinations = _data["destinations"] !== undefined ? _data["destinations"] : [];
            this.sources = _data["sources"] !== undefined ? _data["sources"] : [];
            this.promptPathPhrase = _data["promptPathPhrase"] !== undefined ? _data["promptPathPhrase"] : <any>null;
            this.applicationIsiId = _data["applicationIsiId"] !== undefined ? _data["applicationIsiId"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoCiaFunction): IsiDtoCiaFunction {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoCiaFunction();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["destinations"] = this.destinations !== undefined ? this.destinations : [];
        data["sources"] = this.sources !== undefined ? this.sources : [];
        data["promptPathPhrase"] = this.promptPathPhrase !== undefined ? this.promptPathPhrase : <any>null;
        data["applicationIsiId"] = this.applicationIsiId !== undefined ? this.applicationIsiId : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
/** Dto stockant les informations, descendues coté client, nécessaires au paramètrage d'un sparkle */
export class IsiDtoSparkleForClient extends IsiDataTransferObject implements IIsiDtoSparkleForClient {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.Engine.IsiDtoSparkleForClient, Isilog.IsiFramework.IsiDataTransferObject";
    /** Nom du controle associé au sparkle */
    position?: string;
    /** Nom de la fonction appelé */
    fonction?: IsiDtoCiaFunction[];
    /** Identifiant d'un sparkle */
    id?: string;

    constructor(data?: IIsiDtoSparkleForClient) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.position = _data["position"] !== undefined ? _data["position"] : <any>null;
            this.fonction = _data["fonction"] !== undefined ? _data["fonction"] : [];
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoSparkleForClient): IsiDtoSparkleForClient {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoSparkleForClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["position"] = this.position !== undefined ? this.position : <any>null;
        data["fonction"] = this.fonction !== undefined ? this.fonction : [];
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
/** Dto stockant les informations nécessaires coté client au paramètrage des sparkle d'une instance d'écran. */
export class IsiDtoCiaInstanceScreenForClient extends IsiDataTransferObject implements IIsiDtoCiaInstanceScreenForClient {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.Engine.IsiDtoCiaInstanceScreenForClient, Isilog.IsiFramework.IsiDataTransferObject";
    /** Liste des sparkle définis sur l'écran. */
    sparkles?: IsiDtoSparkleForClient[];
    /** Identifiant de l'instance de l'écran */
    id?: string;

    constructor(data?: IIsiDtoCiaInstanceScreenForClient) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.sparkles = _data["sparkles"] !== undefined ? _data["sparkles"] : [];
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoCiaInstanceScreenForClient): IsiDtoCiaInstanceScreenForClient {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoCiaInstanceScreenForClient();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["sparkles"] = this.sparkles !== undefined ? this.sparkles : [];
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
export interface IIsiDtoPlCiaSource extends IIsiDataTransferObject  {
    valueSource?: string;
    idSource?: string;
}
export class IsiDtoPlCiaSource extends IsiDataTransferObject implements IIsiDtoPlCiaSource {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Cia.IsiDtoPlCiaSource, Isilog.IsiComponent.IsiDataTransferObject";
    valueSource?: string;
    idSource?: string;

    constructor(data?: IIsiDtoPlCiaSource) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.valueSource = _data["valueSource"] !== undefined ? _data["valueSource"] : <any>null;
            this.idSource = _data["idSource"] !== undefined ? _data["idSource"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlCiaSource): IsiDtoPlCiaSource {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCiaSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["valueSource"] = this.valueSource !== undefined ? this.valueSource : <any>null;
        data["idSource"] = this.idSource !== undefined ? this.idSource : <any>null;
        return data;
    }
}
export interface IIsiDtoPlCiaResult extends IIsiDataTransferObject  {
    iaResponse?: string;
    functionId?: string;
}
export class IsiDtoPlCiaResult extends IsiDataTransferObject implements IIsiDtoPlCiaResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Cia.IsiDtoPlCiaResult, Isilog.IsiComponent.IsiDataTransferObject";
    iaResponse?: string;
    functionId?: string;

    constructor(data?: IIsiDtoPlCiaResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.iaResponse = _data["iaResponse"] !== undefined ? _data["iaResponse"] : <any>null;
            this.functionId = _data["functionId"] !== undefined ? _data["functionId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlCiaResult): IsiDtoPlCiaResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCiaResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["iaResponse"] = this.iaResponse !== undefined ? this.iaResponse : <any>null;
        data["functionId"] = this.functionId !== undefined ? this.functionId : <any>null;
        return data;
    }
}
export interface IIsiDtoPlCiaResponse extends IIsiDtoPresentationLogicResponse  {
    getIaResponse?: IIsiDtoPlCiaResult[];
}
export class IsiDtoPlCiaResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlCiaResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Cia.IsiDtoPlCiaResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getIaResponse?: IsiDtoPlCiaResult[];

    constructor(data?: IIsiDtoPlCiaResponse) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getIaResponse = _data["getIaResponse"] !== undefined ? _data["getIaResponse"] : [];
        }
    }

    static fromJS(data?: IIsiDtoPlCiaResponse): IsiDtoPlCiaResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCiaResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getIaResponse"] = this.getIaResponse !== undefined ? this.getIaResponse : [];
        return data;
    }
}
export interface IIsiDtoPlCiaRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlCiaResponse;
    claimNumber?: number;
    category?: string;
    language?: string;
    pageName?: string;
    screenId?: string;
    sparkleId?: string;
    iaRequest?: IIsiDtoPlCiaSource[];
}
export class IsiDtoPlCiaRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlCiaRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.Cia.IsiDtoPlCiaRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlCiaResponse;
    claimNumber?: number;
    category?: string;
    language?: string;
    pageName?: string;
    screenId?: string;
    sparkleId?: string;
    iaRequest?: IsiDtoPlCiaSource[];

    constructor(data?: IIsiDtoPlCiaRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlCiaResponse(data.response) : <IsiDtoPlCiaResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlCiaResponse.fromJS(_data["response"]) : <any>null;
            this.claimNumber = _data["claimNumber"] !== undefined ? _data["claimNumber"] : 0;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            this.language = _data["language"] !== undefined ? _data["language"] : <any>null;
            this.pageName = _data["pageName"] !== undefined ? _data["pageName"] : <any>null;
            this.screenId = _data["screenId"] !== undefined ? _data["screenId"] : <any>null;
            this.sparkleId = _data["sparkleId"] !== undefined ? _data["sparkleId"] : <any>null;
            this.iaRequest = _data["iaRequest"] !== undefined ? _data["iaRequest"] : [];
        }
    }

    static fromJS(data?: IIsiDtoPlCiaRequest): IsiDtoPlCiaRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlCiaRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["claimNumber"] = this.claimNumber !== undefined ? this.claimNumber : 0;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        data["language"] = this.language !== undefined ? this.language : <any>null;
        data["pageName"] = this.pageName !== undefined ? this.pageName : <any>null;
        data["screenId"] = this.screenId !== undefined ? this.screenId : <any>null;
        data["sparkleId"] = this.sparkleId !== undefined ? this.sparkleId : <any>null;
        data["iaRequest"] = this.iaRequest !== undefined ? this.iaRequest : [];
        return data;
    }
}
